/* eslint-disable no-undef */
import Vue from 'vue'
import SvgIcon from '@/components/icon/SvgIcon'

// register

Vue.component('svg-icon', SvgIcon)
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
